import { Injectable, ViewChildren, QueryList } from '@angular/core';
import {
  IonRouterOutlet,
  ActionSheetController,
  PopoverController,
  ModalController,
  MenuController,
  ToastController,
  LoadingController,
} from '@ionic/angular';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AutocloseOverlaysService {
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;

  constructor(
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private menu: MenuController,
    private router: Router,
    private toastController: ToastController,
    private loadingController: LoadingController,
    private translate: TranslateService
  ) {}
  async trigger() {
    // close action sheet
    try {
      const element = await this.actionSheetCtrl.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {}

    // close loader
    try {
      const element = await this.loadingController.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {}

    // close popover
    try {
      const element = await this.popoverCtrl.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {}

    // close modal
    try {
      const element = await this.modalCtrl.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
      console.log(error);
    }

    // close side menua
    try {
      const element = await this.menu.getOpen();
      if (element !== null) {
        this.menu.close();
        return;
      }
    } catch (error) {}

    // console.log('url', this.router.url);
    /*     this.routerOutlets.forEach((outlet: IonRouterOutlet) => {
          if (outlet && outlet.canGoBack()) {
            outlet.pop();
          } else if (this.router.url === '/shopping/food') {
            console.log('***On Home Page');
            if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
              // this.platform.exitApp(); // Exit from app
              navigator['app'].exitApp(); // work for ionic 4
            } else {
              this.presentBackButtonToastWithOptions();
              this.lastTimeBackPress = new Date().getTime();
            }
          }
        }); */
  }
  async presentBackButtonToastWithOptions() {
    const toast = await this.toastController.create({
      header: this.translate.instant('toast_message.press_back_again_to_exit_App'),
      // message: 'Please tap reload to update.',
      position: 'bottom',
      translucent: true,
      duration: 2000,
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          },
        },
      ],
    });
    toast.present();
  }
}
